var path = 'areas/projects/views/create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/new'>Create New</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <help-button></help-button> <h3>Create a project</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <alerts list=alerts></alerts> <project-editor></project-editor> </div> </loading-wrapper> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/create.html
// module id = 4847069933063664
// module chunks = 1